import { Component, OnInit } from '@angular/core';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';

@Component({
  selector: 'modal-compra-online',
  templateUrl: './modal-compra-online.component.html',
  styleUrls: ['./modal-compra-online.component.scss']
})

export class ModalCompraOnlineComponent implements OnInit {

  constructor(private modal: ModalService, private genServ : EcommerceGenericoService) { }

  ngOnInit(): void {
  }

  aceptar() {
    this.modal.close('modal-compra-online');
  }

  get compraOnline(){
    return this.genServ.getinfoCompra()
  }

  get errorMessage() {
    return this.genServ.getErrorMessage();
  }

}
